<template>
    <div class="pci-cart-wrapper">
        <modal :show="showPolicies">
            <div class="pci-policies-overlay">
                <div class="pci-policies-close-bar"><span class="pci-policies-close-btn" @click="showPolicies=false">X</span></div>
                <policies :api-client="{getItemsPrms:apiClient.getPoliciesPrms}" v-if="showPolicies"></policies>
            </div>
        </modal>

        <modal-x :show="showContacts" @onclose="showContacts=false">
            <paged-contact v-on:onselect="onContactSelected" v-if="showContacts"></paged-contact>
        </modal-x>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div ref="container">
                <!-- Toolbar -->
                <div class="pci-toolbar">
                    <span class="pci-toolbar-left">
                        <span class="pci-btn pci-btn-refresh" @click="loadItems">{{lang.common.refresh}}</span>
                    </span>
                    <span class="pci-arrow glyphicon glyphicon-chevron-right"></span>
                    <span class="pci-btn pci-btn-primary" @click="checkout">{{lang.cart.submitOrder}}</span>
                </div>

                <!-- Selected Contact Card -->
                <div v-if="selectedContact!==null" class="pci-contact-card">
                    <div class="pci-contact-header">
                        <span class="pci-contact-title">{{selectedContact.title}}({{selectedContact.id}})</span>
                    </div>
                    <div class="pci-contact-detail">
                        <span class="pci-label">{{lang.common.name}}:</span>{{selectedContact.name}} / <span class="pci-label">{{lang.common.phone}}:</span>{{selectedContact.phone}}
                        <div>
                            <div class="pci-contact-address-label">{{lang.contact.deliveryAddress}}:</div>
                            {{selectedContact.address}}
                        </div>
                        <div v-if="selectedContact.pickContact!==null" class="pci-pickup-section">
                            <div class="pci-pickup-badge">{{lang.common.pickup}}</div>
                            <div>{{selectedContact.pickContact.title}}:{{selectedContact.pickContact.phone}}</div>
                            <div>{{selectedContact.pickContact.address}}</div>
                        </div>
                    </div>
                </div>

                <!-- Shop Groups -->
                <div v-for="grp in itemGroups" class="pci-shop-group" :data-shop-user-id="grp.shop.shopUserId">
                    <div class="pci-shop-header">
                        <h3 class="pci-shop-name">{{grp.shop.shopName}}</h3>
                        <span class="pci-btn-terms" @click="showPolicies=true">{{lang.cart.terms}}</span>
                    </div>
                    <div v-for="item in grp.items" class="ags-carted-item">
                        <div class="pci-item-row" :item-data="item.id">

                            <!-- Image Column -->
                            <div class="pci-item-image-col">
                                <span class="pci-btn-remove" @click="removeCartItem(item)">X</span>
                                <router-link :to="'/detail?postId='+item.postId" class="pci-item-thumb-link">
                                    <img :src="item.post.thumbPath" title="missing image" class="pci-item-thumb">
                                </router-link>
                            </div>

                            <!-- Info Column -->
                            <div class="pci-item-info-col">
                                <div>
                                    <router-link :to="'/detail?postId='+item.postId" class="pci-item-title-link">{{item.title}}</router-link>
                                </div>
                                <div class="pci-item-props">
                                    <span v-for="pc in item.propCats" class="pci-item-prop">
                                        {{pc.parent.name}}:{{pc.child.name}}
                                    </span>
                                </div>
                                <div class="pci-item-price-row">
                                    <span :price-val="item.price" class="pci-item-price">${{item.price}}</span>
                                    <div>
                                        <input class="pci-item-quant-input" type="text" :value="item.quant" @change="updateQuant(item,$event)">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import modal from './base/Modal.vue';
    import modalX from './base/ModalX1.vue'; 
    import policies from './Policies.vue';
    import pagedContact from './PagedContact.vue';
    import localCart from "../api/localCart.js";

    export default {
        components: {
            pagedLoading: pagedLoading,
            modal: modal,
            modalX: modalX,
            policies: policies,
            pagedContact: pagedContact
        },
        //props: ["apiClient", "userId"],
        data: function () {
            return {
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                itemGroups: [],
                showPolicies: false,
                showContacts: false,
                selectedContact: null
            };
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.cartApiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        methods: {
            addToAccountCart: function () {
                this.$router.push("cart");
            },
            updateQuant: function (item,event) {
                console.log('updateQuant val', event.target.value);
                item.quant = event.target.value;
                localCart.api.updateCartItem(item);
            },
            removeCartItem: function (item) {
                console.log("remove item:", item);
                localCart.api.removeItem(item.priceId);
                this.reloadItems();
            },
            onContactSelected: function (contact) {
                console.log("shipto", contact);
                this.selectedContact = contact;
                this.showContacts = false;
            },
            reloadItems: function () {
                var obj = { uid: this.userId };
                this.loadItems(queryString().getString(obj));
            },
            onPageChange: function (newPage) {
                var obj = { page: newPage };
                this.loadItems(queryString().getString(obj));
            },
            checkout: function () {
                //this.$store.commit("setShowLogin", true);
                this.mxnAgxShowLogin(true);
            },
            loadItems: function (query) {
                this.itemGroups = [];
                this.loadingImg = true;

                this.apiClient.setOnRemove((ret) => {
                    console.log("to delete:",ret);
                    /*
                    var itemIds = ret.itemIds;
                    if (ret.ok === true) {
                        for (var i = 0; i < itemIds.length; i++) {
                            var id = itemIds[i];
                            this.itemGroups.forEach((g) => {
                                g.items = g.items.filter((it) => { return it.id != id; });
                            });
                        }
                    }
                    */
                });

                //localCart items
                var lsCartObj = localCart.api.getCart();
                var localCartItems = lsCartObj.items;

                this.apiClient.getLocalCartItemsPrms(localCartItems).done((ret) => {
                    this.loadingImg = false;
                    var filter = ret.filter;
                    this.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.itemGroups = ret.items;

                    this.$nextTick(() => {
                        this.apiClient.registerItem(this.$refs.container);
                    });

                }).fail((ret) => {
                    this.loadingImg = false;
                });
            }
        },
        created: function () {
            this.apiClient.onLoginApi.on(this.addToAccountCart);
            this.reloadItems();
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.addToAccountCart);
        },
        mounted: function () {
            this.apiClient.pingPrms().then((ret) => {
                if (ret.hasLogin === true) {
                    this.addToAccountCart();
                }
            });
        }
    }
</script>